import ListItemNew from './ListItemNew.jsx';

export default ListItemNew;


// WEBPACK FOOTER //
// ./src/components/ListItemNew/index.jsx